import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import DiscountsList from '../DiscountsList';

export interface PackageDiscountsProps {
  finalPrice: string;
  initialPrice: string;
  discounts: {
    vipDiscount?: string;
    tieredSaving?: string;
    packageDiscount?: string;
  };
  tieredSavingEndDate?: string;
  vat: ReactNode;
}

export default function PackageDiscounts(props: PackageDiscountsProps) {
  const { t } = useTranslation();
  const { finalPrice, initialPrice, discounts, tieredSavingEndDate, vat } =
    props;

  const discountsList = [
    {
      name: t('site.pricing.products-selection.price-info.full-price.label'),
      price: initialPrice,
    },
    {
      name: t('site.pricing.products-selection.price-info.tiered-saving.label'),
      subName:
        tieredSavingEndDate &&
        t(
          'site.pricing.products-selection.price-info.tiered-saving.description',
          {
            0: tieredSavingEndDate,
          },
        ),
      price: `-${discounts.tieredSaving}`,
    },
    {
      name: t(
        'site.pricing.products-selection.price-info.vip-code-saving.label',
      ),
      price: `-${discounts.vipDiscount}`,
    },
    {
      name: t(
        'site.pricing.products-selection.price-info.package-discount.label',
      ),
      price: `-${discounts.packageDiscount}`,
    },
  ];

  return (
    <DiscountsList totalPrice={finalPrice} list={discountsList} vat={vat} />
  );
}
